export enum DepositMethodEnum {
  MONOOVA_DIRECT_CREDIT = 4,
  POLI = 5, // POLI decommissioned 2021-09-30
  BPAY = 3,
  MONOOVA_PAYID = 6,
  BANXA = 8,
  NZD_BANK_TRANSFER = 10,
  STRIPE = 11,
}
